export const defaultMixin = {
  computed: {
    loggedIn: function () {
      return !!this.$store.state.accessToken
    },
    isModerator: function () {
      return this.$store.state.userRoles && this.$store.state.userRoles.filter(function (role) { return role === 'MODERATOR' }).length > 0
    },
    isAdmin: function () {
      return this.$store.state.userRoles && this.$store.state.userRoles.filter(function (role) { return role === 'ADMINISTRATOR' }).length > 0
    },
    confirmMessage: function () {
      return {
        title: this.$i18n.t('messages.are_you_sure'),
        yes: this.$i18n.t('messages.yes'),
        no: this.$i18n.t('messages.no')
      }
    }
  },
  methods: {
    slugText: function (text) {
      return this.$options.filters.slug(text).substring(0, 50)
    },
    translateDay: function (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }

      let dayTranslation = 'days.'
      switch (value) {
        case 0:
          dayTranslation += 'sunday'
          break
        case 1:
          dayTranslation += 'monday'
          break
        case 2:
          dayTranslation += 'tuesday'
          break
        case 3:
          dayTranslation += 'wednesday'
          break
        case 4:
          dayTranslation += 'thursday'
          break
        case 5:
          dayTranslation += 'friday'
          break
        case 6:
          dayTranslation += 'saturday'
          break
      }
      return this.$i18n.t(dayTranslation)
    },
    translateDate: function (value) {
      if (!value) {
        return ''
      }

      let split = value.split(' ')
      let dates = split[0].split('-')
      let day = parseInt(dates[2])
      let month = parseInt(dates[1])
      let year = parseInt(dates[0])

      return day + ' ' + this.translateMonth(month + '-' + year) + ' ' + split[1]
    },
    translateMonth: function (value) {
      if (!value) {
        return ''
      }

      let dates = value.split('-')
      let month = parseInt(dates[0])
      let year = parseInt(dates[1])
      let monthTranslation = 'months.'
      switch (month) {
        case 1:
          monthTranslation += 'january'
          break
        case 2:
          monthTranslation += 'february'
          break
        case 3:
          monthTranslation += 'march'
          break
        case 4:
          monthTranslation += 'april'
          break
        case 5:
          monthTranslation += 'may'
          break
        case 6:
          monthTranslation += 'june'
          break
        case 7:
          monthTranslation += 'july'
          break
        case 8:
          monthTranslation += 'august'
          break
        case 9:
          monthTranslation += 'september'
          break
        case 10:
          monthTranslation += 'october'
          break
        case 11:
          monthTranslation += 'november'
          break
        case 12:
          monthTranslation += 'december'
          break
      }
      return this.$i18n.t(monthTranslation).concat(' ').concat(year)
    },
    precision: function (a) {
      if (!isFinite(a)) return 0
      let e = 1
      let p = 0
      while (Math.round(a * e) / e !== a) { e *= 10; p++ }
      return p
    },
    uuid: function () {
      var dt = new Date().getTime()
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return uuid
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/default.js